// Tekster for pipeline pakke 6 (Rapporter → Salg, kap. 14). Hver rapport
// har spørsmålet som overskrift og én setning med hovedtallet.
export const norwegianPipelineReportMessages = {
  crm: {
    sales_reports: {
      help: "Rapportene svarer på ett spørsmål hver. Klikk på en stolpe for å se mulighetene bak tallet.",
      period: "Periode",
      period_days: "Siste %{days} dager",
      period_label: "siste %{days} dager",
      data_from: "Data fra %{date}",
      no_log: "Hendelsesloggen har ingen data ennå.",
      deals_title: "%{label}",
      no_deals: "Ingen muligheter.",
      open_deal: "Åpne",
      none_in_period: "Ingen muligheter i perioden.",
      unknown: "Ukjent",
      no_product: "Uten produkt",
      no_stage: "Ukjent stadium",
      days_short: "%{days} d",
      workdays_short: "%{days} virkedager",
      pipeline: {
        title: "Hva ligger i pipelinen nå?",
        sentence:
          "Pipelinen har %{count} åpne muligheter med årsverdi %{annual}, vektet %{weighted}.",
        empty: "Pipelinen har ingen åpne muligheter utenom Lead inn.",
        split: "Engangs %{oneTime} og månedlig %{monthly}",
        stage: "Stadium",
        count: "Antall",
        one_time: "Engangs",
        monthly: "Månedlig",
        annual: "Årsverdi",
        weighted: "Vektet",
        total: "Totalt",
      },
      win_rate: {
        title: "Hvor ofte vinner vi?",
        sentence:
          "Siste %{days} dager vant vi %{won} av %{closed} avsluttede muligheter (%{rate}), og %{rateValue} av verdien.",
        empty: "Ingen muligheter ble vunnet eller tapt %{period}.",
        footnote:
          "Diskvalifiserte teller ikke. %{count} muligheter ble gjenåpnet som «Avsluttet for tidlig»; tapet deres teller ikke.",
        footnote_none: "Diskvalifiserte teller ikke.",
        by_source: "Per kilde",
        by_product: "Per produkt",
        row: "%{rate} (%{won} av %{closed})",
      },
      loss: {
        title: "Hvorfor taper vi?",
        sentence:
          "Den vanligste tapsårsaken var «%{reason}» (%{count} av %{total} tap).",
        empty: "Vi tapte ingen muligheter %{period}.",
        migrated_note:
          "«Annet (migrert)» er tap fra før pipelinen fikk tapsårsaker, vist i grått.",
        by_stage: "Tapsårsak og stadium ved avslutning",
        reason: "Årsak",
        comments: "Kommentarer og læring",
        comment: "Kommentar",
        learning: "Læring",
      },
      competitors: {
        title: "Hvem taper vi mot?",
        sentence:
          "Vi tapte %{count} av %{total} muligheter til konkurrenter, flest til %{name} (%{top}).",
        empty: "Vi tapte ingen muligheter til konkurrenter %{period}.",
      },
      stage_time: {
        title: "Hvor stopper det opp?",
        sentence:
          "Muligheter blir lengst i «%{stage}», med median %{days} virkedager.",
        empty: "Loggen har ingen avsluttede opphold i et stadium %{period}.",
        note: "Median antall virkedager i stadiet, for opphold som sluttet i perioden.",
      },
      cycle: {
        title: "Hvor lang er salgssyklusen?",
        sentence:
          "Median salgssyklus er %{days} dager fra kvalifisert til vunnet (%{count} muligheter).",
        fallback:
          "Loggen har for lite data ennå (%{count} av %{min} muligheter). Snitt fra opprettet til vunnet er %{days} dager.",
        empty: "Ingen muligheter ble vunnet %{period}.",
        bar_median: "Median fra kvalifisert",
        bar_average: "Snitt fra opprettet",
      },
      sources: {
        title: "Hvor kommer de gode kundene fra?",
        sentence:
          "Flest vunne kom fra %{source}: %{won} vunnet med årsverdi %{value}.",
        empty: "Ingen muligheter ble vunnet %{period}.",
        source: "Kilde",
        leads: "Leads",
        won: "Vunnet",
        won_value: "Årsverdi vunnet",
      },
      won_back: {
        title: "Hvor mange kom tilbake?",
        sentence:
          "%{back} av %{won} vunne muligheter var tilbakevendende (årsverdi %{value}).",
        empty: "Ingen muligheter ble vunnet %{period}.",
        bar: "Tilbakevendende",
        bar_new: "Nye",
      },
      revisit: {
        title: "Hvem skal vi ta opp igjen, og hva har vi lært?",
        sentence:
          "%{count} tapte muligheter skal tas opp igjen de neste 90 dagene, og læringslisten har %{learning} svar.",
        queue: "Revisit-kø (neste 90 dager)",
        queue_empty: "Ingen revisit de neste 90 dagene.",
        learning: "Hva kunne vi gjort annerledes?",
        learning_empty: "Ingen svar ennå.",
      },
    },
  },
};

export const englishPipelineReportMessages = {
  crm: {
    sales_reports: {
      help: "Each report answers one question. Click a bar to see the opportunities behind the number.",
      period: "Period",
      period_days: "Last %{days} days",
      period_label: "in the last %{days} days",
      data_from: "Data from %{date}",
      no_log: "The event log has no data yet.",
      deals_title: "%{label}",
      no_deals: "No opportunities.",
      open_deal: "Open",
      none_in_period: "No opportunities in the period.",
      unknown: "Unknown",
      no_product: "No product",
      no_stage: "Unknown stage",
      days_short: "%{days} d",
      workdays_short: "%{days} workdays",
      pipeline: {
        title: "What is in the pipeline now?",
        sentence:
          "The pipeline has %{count} open opportunities with an annual value of %{annual}, weighted %{weighted}.",
        empty: "The pipeline has no open opportunities outside Lead inbox.",
        split: "One-time %{oneTime} and monthly %{monthly}",
        stage: "Stage",
        count: "Count",
        one_time: "One-time",
        monthly: "Monthly",
        annual: "Annual value",
        weighted: "Weighted",
        total: "Total",
      },
      win_rate: {
        title: "How often do we win?",
        sentence:
          "In the last %{days} days we won %{won} of %{closed} closed opportunities (%{rate}), and %{rateValue} of the value.",
        empty: "No opportunities were won or lost %{period}.",
        footnote:
          "Disqualified leads do not count. %{count} opportunities were reopened as «Closed too early»; their loss does not count.",
        footnote_none: "Disqualified leads do not count.",
        by_source: "By source",
        by_product: "By product",
        row: "%{rate} (%{won} of %{closed})",
      },
      loss: {
        title: "Why do we lose?",
        sentence:
          "The most common loss reason was «%{reason}» (%{count} of %{total} losses).",
        empty: "We lost no opportunities %{period}.",
        migrated_note:
          "«Other (migrated)» are losses from before the pipeline had loss reasons, shown in grey.",
        by_stage: "Loss reason and stage at close",
        reason: "Reason",
        comments: "Comments and learning",
        comment: "Comment",
        learning: "Learning",
      },
      competitors: {
        title: "Who do we lose to?",
        sentence:
          "We lost %{count} of %{total} opportunities to competitors, most to %{name} (%{top}).",
        empty: "We lost no opportunities to competitors %{period}.",
      },
      stage_time: {
        title: "Where do things stall?",
        sentence:
          "Opportunities stay longest in «%{stage}», with a median of %{days} workdays.",
        empty: "The log has no finished stays in a stage %{period}.",
        note: "Median number of workdays in the stage, for stays that ended in the period.",
      },
      cycle: {
        title: "How long is the sales cycle?",
        sentence:
          "The median sales cycle is %{days} days from qualified to won (%{count} opportunities).",
        fallback:
          "The log does not have enough data yet (%{count} of %{min} opportunities). The average from created to won is %{days} days.",
        empty: "No opportunities were won %{period}.",
        bar_median: "Median from qualified",
        bar_average: "Average from created",
      },
      sources: {
        title: "Where do the good customers come from?",
        sentence:
          "Most wins came from %{source}: %{won} won with an annual value of %{value}.",
        empty: "No opportunities were won %{period}.",
        source: "Source",
        leads: "Leads",
        won: "Won",
        won_value: "Annual value won",
      },
      won_back: {
        title: "How many came back?",
        sentence:
          "%{back} of %{won} won opportunities were returning (annual value %{value}).",
        empty: "No opportunities were won %{period}.",
        bar: "Returning",
        bar_new: "New",
      },
      revisit: {
        title: "Who should we revisit, and what have we learned?",
        sentence:
          "%{count} lost opportunities are due for a revisit in the next 90 days, and the learning list has %{learning} answers.",
        queue: "Revisit queue (next 90 days)",
        queue_empty: "No revisits in the next 90 days.",
        learning: "What could we have done differently?",
        learning_empty: "No answers yet.",
      },
    },
  },
};
